/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MccsRoles {
  SYSTEM = 'system',
  ADMINISTRATOR = 'administrator',
  CHIEF_INVESTIGATOR = 'chief_investigator',
  INVESTIGATOR = 'investigator',
  CREDENTIALING_ADMIN = 'credentialing_admin',
  CREDENTIALING = 'credentialing',
  FINANCE = 'finance',
  LEGAL = 'legal',
  AUTONOMOUS_VEHICLE_OWNER = 'autonomous_vehicle_owner',
  AUTONOMOUS_VEHICLE_USER = 'autonomous_vehicle_user',
  MOTOR_CARRIER_OWNER = 'motor_carrier_owner',
  MOTOR_CARRIER_USER = 'motor_carrier_user',
  BROKER = 'broker',
  INSURANCE_PROVIDER = 'insurance_provider',
  LICENSING_AGENCY_OWNER = 'licensing_agency_owner',
  LICENSING_AGENCY_USER = 'licensing_agency_user',
}
